import { useTheme } from '@mui/material/styles'
import Logo from './Logo'
import Navigation from './Navigation'
import Login from './Login'
import { useSelector } from 'react-redux'
import { type IUserProfile } from '../../../redux/api/types'

import { Box, AppBar, Toolbar, useMediaQuery } from '@mui/material'
import DrawerComponent from './Drawer'

const Header: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const user = useSelector((state: { userState: { user: IUserProfile } }) => state.userState.user)
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', borderBottom: 2, borderColor: '#EDEFF2' }}>
      <AppBar position="static" elevation={0}>
        <Toolbar variant="dense" sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, mb: 2 }}>
          <Logo />
          {isMobile
            ? (
          <DrawerComponent />
              )
            : (
          <>
            <Navigation/>
            {user?.isOmniCustomer
              ? null
              : (<Login/>)
            }
          </>
              )}
        </Toolbar>
      </AppBar>
    </Box>
  )
}

export default Header
